<template>
    <div>
        <div class="page-title">身体数据</div>
        
        <profile-plane @planeChanged="planeChanged" :planes="planes" @syncPlane="syncPlane" :activeId="activeId"
                       @changeDefault="changeDefault"
                       @deletePlane="deletePlane"
                       @showMobileLocation="handleShowMobileLocation"
        >
            
            <div class="body-attr-tips"></div>
            
            <div class="body-attr-container" v-if="item">
                
                <template v-for="(attrGroup,gk) in group">
                    
                    <div class="body-attr-list" :key="gk">
                        
                        <img class="body-attr-image" :src="attrGroup.image" alt="">
                        
                        <div class="attr-list">
                            
                            <template v-for="idx of 21">
                                <div class="attr-item" :key="idx">
                                    <div class="attr-icon"></div>
                                    <input v-model="item[attrGroup.prefix + idx]" type="text" maxlength="8"
                                           :disabled=" item.app_id === 0 ">
                                </div>
                            </template>
                        
                        </div>
                    
                    </div>
                
                
                </template>
                
                <button class="btn" @click="save">保存</button>
                
            </div>
        
        </profile-plane>
    
    
    </div>
</template>

<script>

import api from "@/repo/api";
import ProfilePlane from "@/views/AST/MemberProfile/Com/ProfilePlane.vue";

export default {
    name: "Lipstick",
    components: {ProfilePlane},
    data() {
        return {
            planeId: 0,
            showLipstickModal: false,
            params: {},
            planes: [],
            item: null,
            activeId: 0,
            group: [
                {
                    prefix: "woman_field",
                    image: "/assets/images/body-attr-woman.png?v=1.0",
                    name: "女"
                },
                {
                    prefix: "man_field",
                    image: "/assets/images/body-attr-man.png?v=1.0",
                    name: "男"
                }
            ],
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        planeChanged(plane) {
            this.item = plane
            this.activeId = plane.id
        },
        save() {
            this.$loading.show()
            
            const params = JSON.parse(JSON.stringify(this.item))
            
            delete params.id
            delete params.app_id
            delete params.is_default
            
            api.post('/ast-member-profile/save-body-attribute', {
                id: this.item.id,
                params
            }).then(res => {
                this.$loading.hide()
                this.$message.data(res)
            })
        },
        handleShowMobileLocation(){
            this.$previewImages('https://static.ycsd.work/col/body-attribute-preview.png')
        },
        changeDefault(id) {
            
            api.post('/ast-member-profile/change-default-body-attribute', {id}).then(res => {
                
                this.$message.data(res)
                
                if (res.code !== 0) return;
                
                this.planes.forEach(item => {
                    if (item.id === id) {
                        this.$set(item, 'is_default', 1)
                    } else {
                        this.$set(item, 'is_default', 0)
                    }
                })
            })
        },
        syncPlane(params, callback) {
            
            this.$loading.show()
            
            api.post('/ast-member-profile/sync-body-attribute', params).then(res => {
                
                this.$message.data(res)
                
                this.$loading.hide()
                
                if (res.code !== 0) return;
                
                const idx = this.planes.findIndex(item => item.id === params.id)
                
                if (idx === -1) {
                    this.planes.push(res.data)
                } else {
                    this.planes.splice(idx, 1, res.data)
                }
                
                this.activeId = res.data.id
                
                callback()
            })
            
        },
        deletePlane(id) {
            
            this.$confirm({
                title: '确认删除模板吗？',
                type: 'warning',
                onOk: () => {
                    
                    this.$loading.show()
                    
                    api.post('/ast-member-profile/delete-body-attribute', {id}).then(res => {
                        this.$message.data(res)
                        this.$loading.hide()
                        
                        console.clear()
                        
                        this.planes.splice(
                            this.planes.findIndex(item => item.id === id),
                            1
                        )
                    })
                }
            })
            
        },
        getList() {
            api.get('/ast-member-profile/body-attributes').then(res => {
                this.planes = res.data || []
            })
        },
    }
}
</script>

<style scoped lang="less">
.color-tips {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #0000006e;
    color: white;
    height: 40px;
    text-align: center;
    padding-top: 7px;
    pointer-events: none;
}

.lipstick-item {
    width: 96px;
    height: 148px;
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    padding: 16px 10px;
    cursor: pointer;
    
    margin-right: 12px;
    margin-bottom: 12px;
    position: relative;
}

.lipstick-list {
    flex-wrap: wrap;
}

.color-item {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-image: url("/assets/icons/color-add-icon.png");
    background-size: cover;
    margin-left: 6px;
    overflow: hidden;
    
    
    div {
        width: 100%;
        height: 100%;
    }
}

.lipstick-name {
    font-size: 12px;
    color: #333333;
    line-height: 16px;
    text-align: center;
    margin-top: 8px;
}

.lipstick-color {
    margin-top: 4px;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    border: 1px solid #EEEEEE;
}

.add-icon {
    height: 24px;
    background: rgba(251, 176, 59, 0.1);
    border-radius: 0;
    border: 1px solid #FBB03B;
    color: #FBB03B;
}

.body-attr-list {
    
    display: flex;
    padding: 24px;
    
    &:first-child {
        border-bottom: 1px dashed #eee;
    }
}

.body-attr-image {
    width: 184px;
    height: 472px;
}

.attr-list {
    margin-left: 20px;
    flex: 1;
    
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
}

.attr-item {
    background: linear-gradient(90deg, #EDFAFD 0%, #FCFCFC 100%);
    height: 54px;
    width: calc(33.3% - 16px);
    max-width: 236px;
    
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding-left: 16px;
    padding-right: 12px;
    
    .attr-icon {
        width: 20px;
        height: 20px;
        background-image: url("/assets/icons/body-attr-icon.png");
        background-size: contain;
        margin-right: 8px;
    }
    
    input {
        height: 40px;
        background: #FFFFFF;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #EEEEEE;
        outline: #b9b8b8;
        padding: 2px 10px;
        flex: 1;
        width: 50px;
        
        &:disabled {
            background: rgba(238, 238, 238, 0.4);
        }
    }
}

.body-attr-tips {
    width: 292px;
    height: 27px;
    position: absolute;
    background-image: url("/assets/images/body-attribute-tips.png");
    background-size: 100%;
    background-repeat: no-repeat;
    left: 253px;
    top: 55px;
}

</style>